<script setup lang="ts">
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import Button from "primevue/button";

const { t, locale } = useI18n();

function openInNewWindow(link: string) {
    globalThis.open(link, "_blank");
}

function openInApplication(link: string) {
    globalThis.open(link, "_self");
}

function openManual() {
    document.getElementById("user-manual_btn_manual")?.click();
}

const persologWorldMenu = reactive([
    {
        label: computed(() => t("footer.persologWorldMenu.webshop")),
        icon: "pi pi-shopping-cart",
        url: "https://shop.persolog.com/auth/redirect/login?redirectTo=frontend.account.home.page&utm_source=persolog+online&utm_medium=anzeige",
        target: "_blank",
    },
    {
        label: computed(() => t("footer.persologWorldMenu.academy")),
        icon: "pi pi-comments",
        url: "https://academy.persolog.com/?utm_source=persolog+online&utm_medium=anzeige/",
        target: "_blank",
    },
    {
        label: computed(() => t("footer.persologWorldMenu.tools")),
        icon: "pi pi-cog",
        url: "https://tools.persolog.de?utm_source=persolog+online&utm_medium=anzeige",
        target: "_blank",
    },
    {
        label: computed(() => t("footer.persologWorldMenu.website")),
        icon: "pi pi-at",
        url: "https://persolog.com?utm_source=persolog+online&utm_medium=anzeige ",
        target: "_blank",
    },
]);
</script>

<template>
    <div class="py-8 footer-persolog">
        <div class="flex flex-wrap gap-4 footer justify-between">
            <div class="flex flex-col items-start">
                <h5 class="mt-0 mb-2">{{ t("footer.persologWorld") }}</h5>
                <Button
                    v-for="item in persologWorldMenu"
                    :key="item.label"
                    text
                    :icon="item.icon"
                    style="height: 2rem"
                    class="px-2 text-surface"
                    :label="item.label"
                    @click="openInNewWindow(item.url)"
                />
                <Button
                    icon="pi pi-book"
                    text
                    class="px-2 text-surface"
                    :label="t('footer.persologWorldMenu.help')"
                    @click="openManual"
                ></Button>
            </div>

            <div>
                <h5 class="mt-0 mb-2">{{ t("footer.followUs") }}</h5>
                <Button
                    text
                    class="mr-2 text-surface p-2"
                    size="large"
                    icon="pi pi-linkedin"
                    @click="openInNewWindow('https://www.linkedin.com/company/persolog-international/')"
                ></Button>
                <Button
                    text
                    class="mr-2 text-surface p-2"
                    size="large"
                    icon="pi pi-objects-column"
                    @click="openInNewWindow('https://persolog.com/de/blog/')"
                ></Button>
                <Button
                    text
                    class="mr-2 text-surface p-2"
                    size="large"
                    icon="pi pi-megaphone"
                    @click="
                        openInNewWindow(
                            locale === 'de' ? 'https://persolog.com/de/blog/online-world-update/?utm_source=persolog.online&utm_medium=anzeige' : 'https://persolog.com/blog/online-world-update/?utm_source=persolog.online&utm_medium=anzeige',
                        )
                    "
                ></Button>
                <Button
                    text
                    class="mr-2 text-surface p-2"
                    size="large"
                    icon="pi pi-whatsapp"
                    @click="openInNewWindow('https://whatsapp.com/channel/0029VayCada0lwglKV94JC34')"
                ></Button>
            </div>
        </div>
    </div>
    <div class="py-2 socket bg-surface-muted">
        <div class="flex justify-between">
            <Button
                severity="secondary"
                text
                class="px-2"
                label="persolog GmbH"
                @click="openInNewWindow('https://www.persolog.de/')"
            />

            <Button
                severity="secondary"
                text
                class="px-2"
                icon="pi pi-envelope"
                label="support@persolog.com"
                @click="openInApplication('mailto:support@persolog.com')"
            />

            <Button
                severity="secondary"
                text
                class="px-2"
                icon="pi pi-phone"
                label="+49 7232 3699-70"
                @click="openInApplication('tel:+49 7232 3699-70')"
            />

            <div>
                <Button
                    severity="secondary"
                    text
                    class="px-2"
                    :label="t('footer.tos')"
                    @click="openInNewWindow('https://persolog.com/de/general-terms-conditions')"
                />
                <Button
                    severity="secondary"
                    text
                    class="px-2"
                    :label="t('footer.privacy')"
                    @click="openInNewWindow('https://persolog.online/privacy')"
                />
                <Button
                    severity="secondary"
                    text
                    class="px-2"
                    :label="t('footer.legalNotice.label')"
                    @click="openInNewWindow(t('footer.legalNotice.link'))"
                />
                <Button
                    severity="secondary"
                    text
                    class="px-2"
                    :aria-label="`${t('footer.accessibility.label')} (${t('common.newTabDisclaimer')})`"
                    :label="t('footer.accessibility.label')"
                    icon="pi pi-external-link"
                    iconPos="right"
                    @click="openInNewWindow(t('footer.accessibility.link'))"
                />
            </div>
        </div>
        <div class="flex flex-wrap gap-4">
            <div class="flex-1 flex justify-center">
                {{ t("footer.copyright", { year: new Date().getFullYear() }) }}
            </div>
        </div>
    </div>
</template>

<style scoped>
.footer-persolog {
    background-color: var(--p-secondary-500);
    color: white;
}
</style>
